var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"privacy-policy"},[_c('h2',{staticStyle:{"padding-bottom":"30px"}},[_vm._v("PRIVACY POLICY")]),_c('NestedList',{attrs:{"list":_vm.list}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }